import { render, staticRenderFns } from "./AppFilePreview.vue?vue&type=template&id=13ff5cce&"
import script from "./AppFilePreview.vue?vue&type=script&lang=js&"
export * from "./AppFilePreview.vue?vue&type=script&lang=js&"
import style0 from "./AppFilePreview.vue?vue&type=style&index=0&id=13ff5cce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports